import React, { useState, useContext, useEffect, useRef } from 'react';
import Context from "../context/context";
import classnames from 'classnames';

const Checkboxes = props => {
  const { activeFilters, setActiveFilters, filterNav, setFilterNav, setNavStatus} = useContext(Context);
  const {data,  handleClose} = props;
  const elements = data.elements;
  const [open, setOpen] = useState(false);
  
  let checked = [];
  const firstInputRef = useRef(null);

  useEffect(() => {

    if (open && firstInputRef.current) {

      firstInputRef.current.focus();
    }
  }, [open]);


  data.elements.forEach(element => {
    if (activeFilters[data.name].value.indexOf(element.value) > -1){
      checked.push(true)
    } else {
      checked.push(false);
    }
  });



  const handleChange = (position, val, title) => {
    const updatedCheckedState = checked.map((item, index) =>
      index === position ? !item : item
    );
    checked = updatedCheckedState;
    const filter = {...activeFilters[data.name]};
    if (filter.value.indexOf(val) > -1) {
      filter.value.splice(filter.value.indexOf(val), 1);
      filter.selectedTitles.splice(filter.selectedTitles.indexOf(title), 1);
    } else {
      filter.value.push(val);
      filter.selectedTitles.push(title);
    }
    setActiveFilters({...activeFilters,
      [data.name]: filter
    });

  }



  return (
    <fieldset className={classnames('form-section draggable', {
      active: open,
    })} >


    <legend onClick={() => setOpen(!open)}>{data.title}</legend>

    <div className="form-row-container" >
    <div className="form-row" >
      <div className="conditional_target">

      <div className="form-element-section-items form-row">
        {elements.map((element, index) => {
          return (
            <div className="form-element form-element-checkbox" key={data.name + '_' + index}>
              <input
                ref={index === 0 ? firstInputRef : null}
                type="checkbox"
                id={data.name + '_' + index}
                name={data.name}
                value={element.value}
                checked={checked[index]}
                onChange={(e) => handleChange(index, e.target.value, element.title)}
              />
              <label htmlFor={data.name + '_' + index}>{element.title}</label>
            </div>
          )
        }

        )}
        </div>
        </div>
      </div>
    </div>






    </fieldset>
  )
}

export default Checkboxes;
